"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueName = exports.JobType = exports.JobStatus = void 0;
// ============================================
// JOB ENUMS
// ============================================
// Job status enum (shared across all job types)
var JobStatus;
(function (JobStatus) {
    JobStatus["QUEUED"] = "queued";
    JobStatus["IN_PROGRESS"] = "in_progress";
    JobStatus["COMPLETED"] = "completed";
    JobStatus["FAILED"] = "failed";
})(JobStatus || (exports.JobStatus = JobStatus = {}));
// Job type enum
var JobType;
(function (JobType) {
    JobType["XERO_SYNC"] = "xero_sync";
    JobType["PROJECT_GENERATION"] = "project_generation";
})(JobType || (exports.JobType = JobType = {}));
// Queue name enum
var QueueName;
(function (QueueName) {
    QueueName["XERO_SYNC"] = "xero-sync-queue";
    QueueName["PROJECT_GENERATION"] = "project-generation-queue";
})(QueueName || (exports.QueueName = QueueName = {}));
